import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import globalColors from "../styles/globalColors";

type Props =
  | {
      expanding: true;
      onToggle: (section: string) => void;
      open: boolean;
      title: string;
      titleExtra?: React.ReactNode;
      containerStyles?: any;
      headerStyles?: any;
      contentStyles?: any;
    }
  | {
      expanding?: false | null;
      title?: string;
      containerStyles?: any;
      headerStyles?: any;
      contentStyles?: any;
    };

const ContentSection: React.FC<Props> = props => {
  const { children, containerStyles, contentStyles, headerStyles } = props;

  return props.expanding ? (
    <div
      css={[
        styles.collapseContainer,
        {
          ".ant-collapse-item": {
            ...containerStyles,
            ".ant-collapse-header": headerStyles
          }
        }
      ]}
    >
      <Collapse
        bordered={false}
        activeKey={[props.open ? props.title : ""]}
        expandIconPosition="right"
        onChange={() => props.onToggle(props.title)}
        expandIcon={({ isActive }) => (
          <FontAwesomeIcon
            icon={faChevronDown}
            transform={{ rotate: isActive ? 180 : 0 }}
            style={styles.icon}
          />
        )}
      >
        <Collapse.Panel
          header={
            <span css={styles.header}>
              {props.title}
              {props.titleExtra}
            </span>
          }
          key={props.title}
          css={styles.panel}
        >
          <div css={[styles.content, contentStyles]}>{props.children}</div>
        </Collapse.Panel>
      </Collapse>
    </div>
  ) : (
    <div css={styles.noExpandContent}>
      <span css={styles.header}>{props.title}</span>
      {children}
    </div>
  );
};

const styles = {
  collapseContainer: {
    ".ant-collapse-item": {
      borderBottom: "1px solid #eee !important"
    }
  },
  content: {
    backgroundColor: globalColors.white,
    borderRadius: 5,
    padding: "10px 15px",
    margin: "0 0px 0px"
  },
  header: {
    fontSize: 24,
    fontWeight: 600,
    color: globalColors.textSecondary,
    lineHeight: "50px",
    display: "block"
  },
  icon: {
    fontSize: 20,
    color: globalColors.textSecondary,
    marginRight: 15
  },
  noExpandContent: {
    backgroundColor: "white",
    padding: 24,
    borderRadius: 10,
    border: "1px solid #eee",
    marginBottom: 30
  },
  panel: {
    borderRadius: "10px !important",
    marginBottom: 24,
    padding: 0,
    border: "1px solid #eee",
    overflow: "hidden",
    ".ant-collapse-content-box": {
      padding: 0
    }
  }
};

export default ContentSection;
